import React, { Fragment } from 'react'

export default (el,i) => <Fragment key={i}>{el}</Fragment>;